<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left car-data-col">
                        Gyártási év
                    </th>
                    <th class="text-left car-data-col">
                        Gyártmány
                    </th>
                    <th class="text-left car-data-col">
                        Típus
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td class="car-data-col">
                        {{
                            loadedCarData.gyartev
                                ? loadedCarData.gyartev
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.gyartmany_nev
                                ? loadedCarData.gyartmany_nev
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.tipus
                                ? loadedCarData.tipus
                                : ''
                        }}
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        Üzemanyag
                    </th>
                    <th class="text-left">
                        Hengerűrtartalom
                    </th>
                    <th class="text-left">
                        Teljesítmény
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td class="car-data-col">
                        {{
                            loadedCarData.uzemanyag
                                ? loadedCarData.uzemanyag
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.hengerurtartalom
                                ? loadedCarData.hengerurtartalom
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.teljesitmeny_kw
                                ? loadedCarData.teljesitmeny_kw
                                : ''
                        }}
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th style="width: 33.33%" class="text-left">
                        Ajtók száma
                    </th>
                    <th style="width: 33.33%" class="text-left">
                        Váltó típusa
                    </th>
                    <th style="width: 33.33%" class="text-left">
                        Szállítható személyek száma
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td class="car-data-col">
                        {{
                            loadedCarData.ajtok_szama
                                ? loadedCarData.ajtok_szama
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.valto_tipusa
                                ? loadedCarData.valto_tipusa
                                : ''
                        }}
                    </td>
                    <td class="car-data-col">
                        {{
                            loadedCarData.szallszem
                                ? loadedCarData.szallszem
                                : ''
                        }}
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    name: 'LoadedCarData',
    props: {
        loadedCarData: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.car-data-col {
    width: 33.33%;
}
</style>
